import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于宅男视频',
  description: '宅男视频品牌介绍、用户口碑与联系方式。接入久久视频、小蓝视频、豆花视频等稳定平台，提供流畅高清在线观看体验。',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://zhainanvideo.com/' },
    { '@type': 'ListItem', position: 2, name: '关于我们' },
  ],
};

export default function About() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-4xl mx-auto">
              <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-3" aria-label="面包屑导航">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </div>
                <span className="text-foreground-800 font-medium">关于我们</span>
              </nav>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                关于宅男视频
              </h1>
            </div>
          </div>
        </div>

        {/* Brand Introduction */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                品牌介绍
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  <strong>宅男视频</strong>是一个专注于提供<strong>流畅高清在线观看</strong>体验的视频聚合平台。
                  我们深知用户在观看视频时最在意的就是<strong>不缓冲、不卡顿</strong>，因此我们投入大量技术资源，
                  接入了<strong>久久视频</strong>、<strong>小蓝视频</strong>、<strong>豆花视频</strong>等多个稳定视频平台，
                  确保每一位用户都能享受到丝滑流畅的观影体验。
                </p>
                <p>
                  无论是最新上映的电影大片、热播电视剧、人气动漫、精彩综艺，还是深度纪录片，
                  宅男视频都为你一网打尽。我们的内容库每日更新，让你不错过任何精彩。
                </p>
                <p>
                  宅男视频流畅版是我们的核心产品，采用了智能预加载、自适应码率、P2P加速等先进技术，
                  让你在网络环境不稳定的情况下也能获得出色的观影体验。<strong>久用不卡顿</strong>，这是我们不变的承诺。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation */}
        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    name: '小明',
                    role: '资深影迷',
                    content: '用了宅男视频之后，再也没有遇到过缓冲的问题。久久视频、小蓝视频的片源都很稳定，画质也很清晰，强烈推荐！',
                    rating: 5,
                  },
                  {
                    name: '阿杰',
                    role: '追剧达人',
                    content: '每天下班就靠宅男视频追剧了，豆花视频的内容更新速度真的快，热门剧集当天就能看，太方便了！',
                    rating: 5,
                  },
                  {
                    name: '老王',
                    role: '动漫爱好者',
                    content: '宅男视频流畅版确实名不虚传，看动漫再也不卡了。片源丰富，分类清晰，找片非常方便。久用不卡顿是真的！',
                    rating: 5,
                  },
                ].map((review, idx) => (
                  <div key={idx} className="bg-background-50 rounded-xl p-5 border border-background-200/60">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-500 text-sm"></i>
                        </div>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      &ldquo;{review.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                        <i className="ri-user-line text-lg"></i>
                      </div>
                      <div>
                        <div className="text-sm font-semibold text-foreground-800">{review.name}</div>
                        <div className="text-xs text-foreground-400">{review.role}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-500">contact@zhainanvideo.com</p>
                    <p className="text-xs text-foreground-400 mt-1">商务合作、意见反馈请发送至此邮箱</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 flex-shrink-0">
                    <i className="ri-customer-service-2-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h3>
                    <p className="text-sm text-foreground-500">7×24小时在线服务</p>
                    <p className="text-xs text-foreground-400 mt-1">点击右下角客服图标即可咨询</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-shield-check-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">安全承诺</h3>
                    <p className="text-sm text-foreground-500">绿色安全 · 无广告弹窗 · 无恶意插件</p>
                    <p className="text-xs text-foreground-400 mt-1">我们重视每一位用户的隐私与安全</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/60 flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-links-line text-xl"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">合作平台</h3>
                    <p className="text-sm text-foreground-500">久久视频 · 小蓝视频 · 豆花视频</p>
                    <p className="text-xs text-foreground-400 mt-1">多平台深度合作，片源更稳定</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}